<script lang="ts" setup>
defineProps<{
  icon: string,
  heightDesktop?: string,
  heightMobile?: string
}>()
</script>

<template>
  <div>
    <img :src="icon" alt="payment icon" class="icon-sizes object-contain h-[32px] lg:h-[56px]" loading="lazy" />
  </div>
</template>
<style>

</style>
